<template>

  <div class="eol-container-box">
    <a-button type="link" class="back-class-btn" @click="$router.go(-1)">{{btnTxt}}</a-button>
    <div class="res-content">
      <div class="res-sbumit-content">
        <div class="sbumit-title">提交人</div>
        <div class="sbumit-list">
          <div class="sbumit-item" v-for="(item) in members" :key="item.id">
            <div class="item-title">
              姓名：{{item.name}}
            </div>
            <div class="item-title">
              账号：{{item.username}}
            </div>
            <div class="item-title">
              手机号：{{item.mobile}}
            </div>
            <div class="item-title">
              所属班级：{{item.class_name}}
            </div>
          </div>
        </div>
      </div>
      <div class="story-content">
        <div class="story-title">文物故事提交</div>
        <div class="story-info">
          <div class="info-title">{{storyInfo.name}}</div>
          <div class="info-text">
            {{storyInfo.intro}}
          </div>
          <div class="info-files">
            <div class="files-item" v-for="(item) in attachments" :key="item.id">

              <!-- <div class="item-img coverting" v-if="item.covert_status == 1"></div> -->

              <div :class="`item-img state-${item.type} coverting-${item.covert_status}`" :style="`background-image: url('${item.type == 1 ? item.view_url : item.cover}')`"></div>
              <div class="item-text">{{item.filename + "." + item.file_format}}</div>
              <div class="item-setting">
                <div class="item-btn" @click="previewRes(item)">预览</div>
                <div class="item-btn" @click="downloadResource(item,1)">下载</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="score-content">
      <div class="radio-list">
        <div :class="`radio-item ${scoreId == item.value ? 'active':''}`" v-for="(item) in plainOptions" :key="item.value" @click="scoreId = item.value">
          {{item.label}}
        </div>
      </div>
      <div class="score-submit" @click="scoreSubmit">确定</div>

    </div>
    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${downloadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>

  </div>

</template>
<script>
import { mapActions } from "vuex";
import { downloadFile, downloadVideoFile, getDownloadUrl } from '../../../../assets/js/downloadUtils'; // 引入封装的方法

export default {
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回',
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      plainOptions: [
        { label: '优秀', value: '2' },
        { label: '中等', value: '3' },
        { label: '良好', value: '4' },
        { label: '较差', value: '5' },
      ],
      storyId: "",
      classId: "",
      members: [],
      storyInfo: {},
      attachments: [],
      scoreId: "",
      downloadProgress: 0,
      loading: false,
    }
  },
  components: {
    PreviewPdf: () => import('../../../../components/PreviewPdf'),
    PlayBox: () => import('../../../../components/PlayBox'),
  },
  created() {
    this.storyId = this.$route.query.id;
    this.classId = this.$route.query.cid;
    this.getClassReviewInfo()
  },
  methods: {
    ...mapActions(["gethsjrClassReviewInfo", "setscoreSubmit"]),
    getClassReviewInfo() {
      this.gethsjrClassReviewInfo({
        id: this.storyId,
        data: {
          class_id: this.classId
        }
      }).then(res => {
        if (res.code == "0000") {
          this.members = res.data.members;
          this.storyInfo = res.data.story;
          this.attachments = res.data.attachments;
          this.scoreId = res.data.story.approve_status
        }
      })
    },
    // 预览资源
    previewRes(item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1 || item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
    // 下载附件
    async downloadResource(row, downloadType) {
      try {
        this.loading = true;
        this.downloadProgress = 0;

        if (downloadType == 1) {
          // 课程资源下载
          if (row.type != 1 && row.type != 2 && row.covert_status == 1) {
            return this.$message.error("请等待转码完成后下载");
          }
          if (row.type == 3) {
            // 视频文件下载
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl("/api/school/train/venue/story/download", {
              id: row.id,
              story_id: this.storyId,
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        }
      } catch (error) {
        console.error("下载失败", error);
        this.$message.error("下载失败");
      } finally {
        this.loading = false;
      }
    },
    // 文件流统一处理
    createUrlBlob(url, fileName) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', fileName);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    scoreSubmit() {
      if (this.scoreId != "1") {
        this.setscoreSubmit({
          _method: "put",
          class_id: this.classId,
          story_id: this.storyId,
          approve_status: this.scoreId
        }).then(res => {
          if (res.code == "0000") {
            this.$message.success(`评分成功`)

          }
        })
      } else {
        this.$message.error(`请选择评阅等级`)
      }

    }
  }
}
</script>


<style lang="less" scoped>
.eol-container-box {
  position: relative;
  padding-bottom: 50px;
}
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
.res-content {
  background: #ffffff;
  border: 1px solid #e7eaec;
  padding: 16px 25px 25px;
  .res-sbumit-content {
    display: flex;
    .sbumit-title {
      width: 86px;
      height: 28px;
      background: #bc7a6e;
      border-radius: 14px 0px 0px 14px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
    }
    .sbumit-list {
      flex: 1;
      background: #f8f8f8;
      padding: 10px 12px;
      max-height: 86px;
      overflow-y: auto;
      .sbumit-item {
        display: flex;
        // &:first-child {
        //   margin-top: 10px;
        // }
        // &:last-child {
        //   margin-bottom: 10px;
        // }
        .item-title {
          min-width: 200px;
          font-weight: 400;
          font-size: 14px;
          color: #2f2626;
        }
      }
    }
  }
  .story-content {
    margin-top: 24px;
    .story-title {
      height: 32px;
      background: #b84b3c;
      padding-left: 15px;
      line-height: 32px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
    }
    .story-info {
      background: #f8f8f8;
      padding: 25px 16px 22px;
      .info-title {
        font-weight: bold;
        font-size: 15px;
        color: #333333;
        line-height: 20px;
        &::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 17px;
          background: #a82822;
          vertical-align: -2px;
          margin-right: 9px;
        }
      }
      .info-text {
        font-weight: 400;
        font-size: 14px;
        color: #6d6b6b;
        line-height: 24px;
        margin-top: 15px;
      }
      .info-files {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;

        .files-item {
          background: #fff;
          width: 236px;
          margin-right: 26px;
          padding-bottom: 14px;

          .item-img {
            width: 236px;
            height: 133px;
            background-size: cover;
            background-position: center;
            &.coverting-1 {
              background-image: url("../../../../assets/image/student/unitTwo/translate.png") !important;
              &::before {
                display: none !important;
              }
            }
            &.transerror-3 {
              background-image: url("../../../../assets/image/student/unitTwo/transerror.jpg") !important;
              &::before {
                display: none !important;
              }
            }
            &.state-3 {
              position: relative;
              &::before {
                content: "";
                display: block;
                width: 50px;
                height: 50px;
                background-image: url("../../../../assets/image/school/common/video-start.png");
                background-size: cover;
                background-position: center;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
            &.state-4 {
              position: relative;
              &::before {
                content: "";
                display: block;
                width: 50px;
                height: 50px;
                background-image: url("../../../../assets/image/student/unitTwo/file-word.png");
                background-size: cover;
                background-position: center;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
            &.state-2 {
              position: relative;
              &::before {
                content: "";
                display: block;
                width: 50px;
                height: 50px;
                background-image: url("../../../../assets/image/student/unitTwo/file-audio.png");
                background-size: cover;
                background-position: center;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
          .item-text {
            padding: 12px;
            font-weight: 400;
            font-size: 14px;
            color: #3c3c3e;
            line-height: 20px;
            height: 64px;
          }
          .item-setting {
            border-radius: 14px;
            overflow: hidden;
            display: flex;
            margin: 0 14px;
            justify-content: space-between;
            .item-btn {
              cursor: pointer;
              width: calc(50% - 2px);
              background-color: #ffecee;
              font-weight: 400;
              font-size: 14px;
              color: #a82822;
              line-height: 28px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
.score-content {
  display: flex;
  margin-top: 34px;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  height: 50px;
  bottom: 39px;
  right: 46px;
  width: calc(100% - 269px);
  background-color: #fff;

  .radio-list {
    display: flex;

    .radio-item {
      font-weight: bold;
      font-size: 14px;
      margin-right: 40px;
      color: #3c3c3e;
      &.active {
        &::before {
          content: "";
          display: inline-block;
          background: #ffffff;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 0px solid #d8dbe1;
          vertical-align: -3px;
          margin-right: 7px;
          cursor: pointer;
          background-image: url("../../../../assets/image/school/common/radio-active.png");
          background-size: cover;
        }
      }
      &::before {
        content: "";
        display: inline-block;
        background: #ffffff;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 2px solid #d8dbe1;
        vertical-align: -3px;
        margin-right: 7px;
        cursor: pointer;
      }
    }
  }
  .score-submit {
    width: 60px;
    height: 32px;
    background: #a82822;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }
}
</style>